// An encoding of Table A-1: Basic allowable Stresses
// material	spec	grade	tensilte	yield_0	yield_100	yield_200	yield_300
// A285 Gr. A	A134		45	24	15	14.7	14.2
// A285 Gr. A	A672	A45	45	24	15	14.7	14.2
// Butt Weld	API 5L	A25	45	25	15	15	14.7
// Smls & ERW	API 5L	A25	45	25	15	15	14.7
// Smls & ERW	A179	A25	47	26	15.7	15.7	15.3
// Type F	A53	A	48	30	16	16	16
// Type F	A139	A	48	30	16	16	16
// Type F	A587	A	48	30	16	16	16
// Type F	A53	A	48	30	16	16	16  TODO: This is a duplicate
// Type F	A106	A	48	30	16	16	16
// Type F	A135	A	48	30	16	16	16
// Type F	A369	FPA	48	30	16	16	16
// Type F	API 5L	A	48	30	16	16	16
// A285 Gr. B	A134	A	50	27	16.7	16.5	15.9
// A285 Gr. B	A672	A50	50	27	16.7	16.5	15.9
// A285 Gr. C	A134	A50	55	30	18.3	18.3	17.7
// A285 Gr. C	A524	II	55	30	18.3	18.3	17.7
// A285 Gr. C	A333	1	55	30	18.3	18.3	17.7
// A285 Gr. C	A334	1	55	30	18.3	18.3	17.7
// A285 Gr. C	A671	CA55	55	30	18.3	18.3	17.7
// A285 Gr. C	A672	A55	55	30	18.3	18.3	17.7
// A285 Gr. 55	A672	C55	55	30	18.3	18.3	17.7
// A516 Gr. 60	A671	CC60	60	32	20	19.5	18.9
// A515 Gr. 60	A671	CB60	60	32	20	19.5	18.9
// A515 Gr. 60	A672	B60	60	32	20	19.5	18.9
// A516 Gr. 60	A672	C60	60	32	20	19.5	18.9
// A516 Gr. 60	A139	B	60	35	20	20	20
// A516 Gr. 60	A135	B	60	35	20	20	20
// A516 Gr. 60	A524	I	60	35	20	20	20
// A516 Gr. 60	A53	B	60	35	20	20	20
// A516 Gr. 60	A106	B	60	35	20	20	20
// A516 Gr. 60	A333	6	60	35	20	20	20
// A516 Gr. 60	A334	6	60	35	20	20	20
// A516 Gr. 60	A369	FPB	60	35	20	20	20
// A516 Gr. 60	A381	Y35	60	35	20	20	20
// A516 Gr. 60	API 5L	B	60	35	20	20	20

import { GeckoMeasurement, GeckoMeasurementUnit } from 'types'

export interface MinStrengthRec {
  material: string
  spec: string
  grade: string | null
  tensile: GeckoMeasurement
  yield: {
    0: GeckoMeasurement
    100: GeckoMeasurement
    200: GeckoMeasurement
    300: GeckoMeasurement
  }
}

export const minStrengthRecords: readonly MinStrengthRec[] = [
  {
    material: 'A285 Gr. A',
    spec: 'A134',
    grade: null,
    tensile: GeckoMeasurement.CreateFromValue(
      45 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        24 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        15 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        14.7 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        14.2 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A285 Gr. A',
    spec: 'A672',
    grade: 'A45',
    tensile: GeckoMeasurement.CreateFromValue(
      45 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        24 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        15 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        14.7 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        14.2 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'Butt Weld',
    spec: 'API 5L',
    grade: 'A25',
    tensile: GeckoMeasurement.CreateFromValue(
      45 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        25 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        15 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        15 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        14.7 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'Smls & ERW',
    spec: 'API 5L',
    grade: 'A25',
    tensile: GeckoMeasurement.CreateFromValue(
      45 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        25 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        15 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        15 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        14.7 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'Smls & ERW',
    spec: 'A179',
    grade: 'A25',
    tensile: GeckoMeasurement.CreateFromValue(
      47 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        26 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        15.7 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        15.7 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        15.3 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'Type F',
    spec: 'A139',
    grade: 'A',
    tensile: GeckoMeasurement.CreateFromValue(
      48 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        30 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'Type F',
    spec: 'A587',
    grade: 'A',
    tensile: GeckoMeasurement.CreateFromValue(
      48 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        30 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'Type F',
    spec: 'A53',
    grade: 'A',
    tensile: GeckoMeasurement.CreateFromValue(
      48 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        30 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'Type F',
    spec: 'A106',
    grade: 'A',
    tensile: GeckoMeasurement.CreateFromValue(
      48 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        30 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'Type F',
    spec: 'A135',
    grade: 'A',
    tensile: GeckoMeasurement.CreateFromValue(
      48 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        30 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'Type F',
    spec: 'A369',
    grade: 'FPA',
    tensile: GeckoMeasurement.CreateFromValue(
      48 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        30 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'Type F',
    spec: 'API 5L',
    grade: 'A',
    tensile: GeckoMeasurement.CreateFromValue(
      48 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        30 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        16 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A285 Gr. B',
    spec: 'A134',
    grade: 'A',
    tensile: GeckoMeasurement.CreateFromValue(
      50 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        27 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        16.7 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        16.5 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        15.9 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A285 Gr. B',
    spec: 'A672',
    grade: 'A50',
    tensile: GeckoMeasurement.CreateFromValue(
      50 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        27 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        16.7 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        16.5 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        15.9 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A285 Gr. C',
    spec: 'A134',
    grade: 'A50',
    tensile: GeckoMeasurement.CreateFromValue(
      55 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        30 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        18.3 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        18.3 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        17.7 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A285 Gr. C',
    spec: 'A524',
    grade: 'II',
    tensile: GeckoMeasurement.CreateFromValue(
      55 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        30 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        18.3 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        18.3 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        17.7 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A285 Gr. C',
    spec: 'A333',
    grade: '1',
    tensile: GeckoMeasurement.CreateFromValue(
      55 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        30 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        18.3 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        18.3 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        17.7 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A285 Gr. C',
    spec: 'A334',
    grade: '1',
    tensile: GeckoMeasurement.CreateFromValue(
      55 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        30 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        18.3 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        18.3 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        17.7 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A285 Gr. C',
    spec: 'A671',
    grade: 'CA55',
    tensile: GeckoMeasurement.CreateFromValue(
      55 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        30 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        18.3 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        18.3 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        17.7 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A285 Gr. C',
    spec: 'A672',
    grade: 'A55',
    tensile: GeckoMeasurement.CreateFromValue(
      55 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        30 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        18.3 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        18.3 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        17.7 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A285 Gr. 55',
    spec: 'A672',
    grade: 'C55',
    tensile: GeckoMeasurement.CreateFromValue(
      55 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        30 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        18.3 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        18.3 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        17.7 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A516 Gr. 60',
    spec: 'A671',
    grade: 'CC60',
    tensile: GeckoMeasurement.CreateFromValue(
      60 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        32 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        19.5 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        18.9 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A515 Gr. 60',
    spec: 'A671',
    grade: 'CB60',
    tensile: GeckoMeasurement.CreateFromValue(
      60 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        32 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        19.5 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        18.9 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A515 Gr. 60',
    spec: 'A672',
    grade: 'B60',
    tensile: GeckoMeasurement.CreateFromValue(
      60 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        32 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        19.5 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        18.9 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A516 Gr. 60',
    spec: 'A672',
    grade: 'C60',
    tensile: GeckoMeasurement.CreateFromValue(
      60 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        32 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        19.5 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        18.9 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A516 Gr. 60',
    spec: 'A139',
    grade: 'B',
    tensile: GeckoMeasurement.CreateFromValue(
      60 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        35 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A516 Gr. 60',
    spec: 'A135',
    grade: 'B',
    tensile: GeckoMeasurement.CreateFromValue(
      60 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        35 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A516 Gr. 60',
    spec: 'A524',
    grade: 'I',
    tensile: GeckoMeasurement.CreateFromValue(
      60 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        35 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A516 Gr. 60',
    spec: 'A53',
    grade: 'B',
    tensile: GeckoMeasurement.CreateFromValue(
      60 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        35 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A516 Gr. 60',
    spec: 'A106',
    grade: 'B',
    tensile: GeckoMeasurement.CreateFromValue(
      60 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        35 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A516 Gr. 60',
    spec: 'A333',
    grade: '6',
    tensile: GeckoMeasurement.CreateFromValue(
      60 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        35 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A516 Gr. 60',
    spec: 'A334',
    grade: '6',
    tensile: GeckoMeasurement.CreateFromValue(
      60 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        35 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A516 Gr. 60',
    spec: 'A369',
    grade: 'FPB',
    tensile: GeckoMeasurement.CreateFromValue(
      60 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        35 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A516 Gr. 60',
    spec: 'A381',
    grade: 'Y35',
    tensile: GeckoMeasurement.CreateFromValue(
      60 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        35 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
  {
    material: 'A516 Gr. 60',
    spec: 'API 5L',
    grade: 'B',
    tensile: GeckoMeasurement.CreateFromValue(
      60 * 1000,
      GeckoMeasurementUnit.PoundsForcePerSqInch
    ),
    yield: {
      0: GeckoMeasurement.CreateFromValue(
        35 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      100: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      200: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
      300: GeckoMeasurement.CreateFromValue(
        20 * 1000,
        GeckoMeasurementUnit.PoundsForcePerSqInch
      ),
    },
  },
]
